
import { Component, Vue, Watch, Prop, ProvideReactive, Provide } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

import api from "@/services/api"
import FileService from "@/services/file-service"
import { MapProvider } from "@/services/mapProvider"

import { CaseError } from "@/types/caseError"

import LayoutHost from "@/components/CaseDetails/Layout/LayoutHost.vue"
import { CaseDetails, CaseSummary, Template, TemplateDetails, User } from "@/types"

import {
	applyTemplate,
	updateCaseDetails
} from "@/scripts/caseDetails"
import { update } from "lodash"
const caseStore = namespace("cases")

@Component({
	components: {
		"layout-host": LayoutHost,
		"desktop": () => import("@/components/CaseDetails/Layout/Desktop.vue")
	}
})
export default class CasePopup extends Vue {
	@Provide("mapProvider") mapProvider: MapProvider = new MapProvider()
	@Provide("fileService") fileService: FileService = new FileService(this.caseFilesChanged)

	@Prop({ default: null })
	value!: CaseSummary | null

	@Getter("getMe") public me!: User
	@Getter("getCaseName") getCaseName!: string;
	@Getter("getRecordName") getRecordName!: string;

	@caseStore.Mutation private setCaseToast!: (message: string | null) => void

	@caseStore.Action public caseCreate!: (caseDetails: CaseDetails) => {
		created: CaseDetails,
		errors: CaseError[]
	};

	private currentCase: CaseDetails | null = null

	private currentTemplate: TemplateDetails | null = null
	private templates: { [key:string]: TemplateDetails } = {}

	get open (): boolean {
		return !!this.value
	}

	set open (value: boolean) {
		if (!value) {
			this.$emit("input", null)
		}
	}

	get caseTitle () {
		if (!this.currentCase) return ""
		return `${this.currentCase.templateTitle} ${this.currentCase.isCase ? this.getCaseName : this.getRecordName} #${this.currentCase.caseNumber}`
	}

	@Watch("value")
	async valueUpdated (newValue: CaseSummary | null) {
		if (newValue && newValue.caseNumber) {
			this.currentCase = await api.caseDetails(newValue.caseNumber)

			if (this.currentCase.templateId) {
				const templateId = this.currentCase.templateId
				if (this.templates[templateId]) {
					this.currentTemplate = this.templates[templateId]
				} else {
					api.templateDetails(this.currentCase.templateId!).then(template => {
						if (this.currentCase && this.currentCase.templateId === templateId) {
							this.currentTemplate = this.templates[templateId] = template
						}
					})
				}
			}
		} else {
			this.currentCase = null
			this.currentTemplate = null
		}
	}

	private close () {
		this.$emit("input", null)
	}

	private caseFilesChanged () {
	}

	private updateCurrentCase (updated: CaseDetails) {
		if (this.currentCase) {
			updateCaseDetails(this.currentCase, updated)
		}
	}

	private updateCurrentCaseUsers (viewingUsers: User[]) {
		if (this.currentCase) {
			this.currentCase!.viewingUsers = viewingUsers
		}
	}

	private setCaseEvents () {

	}

	private caseNoLongerAvailable () {
		if (this.currentCase) {
			this.setCaseToast(`#${this.currentCase.caseNumber} is no longer available. You may not have access to it, or it may have been removed.`)
		}
		this.open = false
	}

	private caseClosed () {
		this.open = false
	}

	private closed () {
		if (this.currentCase) {
			this.$emit("closed", {
				id: this.currentCase.id,
				title: this.currentCase.title,
				created: this.currentCase.created,
				closed: this.currentCase.closed,
				caseNumber: this.currentCase.caseNumber
			})
		}
	}
}

